<template>
    <vue-ins-progress-bar></vue-ins-progress-bar>
</template>
<script>
    export default {
        name: 'ProgressIndicator',
        methods: {
            start() {
                this.$insProgress.start();
            },
            stop() {
                this.$insProgress.finish();
            },
        },
    };
</script>
